/* eslint-disable no-param-reassign */
import axios from 'axios'

const geolocationApi = axios.create({
  baseURL: 'https://nominatim.openstreetmap.org/',
})

export default geolocationApi
